import React, { Component, useMemo } from 'react'
import PropTypes from 'prop-types'
import Block from './Block'
import { connect } from 'react-redux'
import {
  embedModeSelector,
  modeSelector
} from '../../../store/selectors/selectors'
import {
  blockHoverIn,
  blockHoverOut
} from '../../../store/actions/selectedBlocks'
import Rectangle from '../../../utils/Rectangle'
import {
  colWidthSelector,
  cropBlockIdSelector
} from '../../../store/selectors/boardSelectors'
import getUrl from '../../../utils/getUrl'
import isEqual from 'lodash/isEqual'

const enhance = connect(
  (state, { block }) => ({
    mode: modeSelector(state),
    colWidth: colWidthSelector(state),
    embedMode: embedModeSelector(state),
    active: cropBlockIdSelector(state) === block.id
  }),
  {
    blockHoverIn,
    blockHoverOut
  }
)
export class BlockContainer extends Component {
  state = {
    contextMenu: null
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextState.contextMenu !== this.state.contextMenu) return true
    for (const key in nextProps) {
      if (key === 'block' || key === 'groupLayout') {
        if (!isEqual(this.props[key], nextProps[key])) return true
      } else {
        if (this.props[key] !== nextProps[key]) return true
      }
    }
    return false
  }

  handleClick = () => {
    const { block, mode, embedMode } = this.props

    // no click through in edit mode
    if (mode === 'edit') return

    // Hide content menu, do nothing else
    if (this.state.contextMenu) return

    if (!block.image && !block.embed) return // only click through on blocks that have src (not text or color blocks)

    const { history, route } = this.context.router
    // this.context.saveBoardScroll()
    const params = route.match.params
    let path =
      getUrl({ id: params.boardId, type: 'board', name: params.boardName }) +
      `${block.id}`
    path += embedMode ? '.embed/' : '/'
    history.push(path, { fromBoard: true })
  }

  showContextMenu = e => {
    if (this.state.contextMenu) return

    const { mode, block } = this.props
    // not in edit/discuss mode
    if (mode === 'edit') return

    // only image blocks for now
    if (!block.image) return

    let target = e.target
    let top = e.pageY
    let left = e.pageX
    while (target.offsetParent) {
      top -= target.offsetTop
      top += target.scrollTop
      left -= target.offsetLeft
      left += target.scrollLeft
      target = target.offsetParent
    }
    this.setState({ contextMenu: { top, left } })

    e.preventDefault()
  }

  closeContextMenu = () => {
    this.setState({ contextMenu: null })
  }

  render() {
    const { block, active, groupLayout, colWidth, mode } = this.props
    if (!block) return null

    return (
      <BlockWithHooks
        {...{ block, active, groupLayout, colWidth, mode }}
        onContextMenu={this.showContextMenu}
        closeContextMenu={this.closeContextMenu}
        contextMenu={this.state.contextMenu}
        onClick={this.handleClick}
      />
    )
  }

  static contextTypes = {
    router: PropTypes.object
    // saveBoardScroll: PropTypes.func
  }

  static propTypes = {
    block: PropTypes.object.isRequired,
    mode: PropTypes.string.isRequired
  }
}

// temp
const BlockWithHooks = ({
  block,
  active,
  groupLayout,
  colWidth,
  mode,
  ...props
}) => {
  if (!block) return null

  const { width, height, top, left } = block.layout

  const layout = useMemo(
    () =>
      new Rectangle({
        width,
        height,
        top: top - groupLayout.top,
        left: left - groupLayout.left
      }).scale(colWidth).style,
    [width, height, top, groupLayout.top, left, groupLayout.left, colWidth]
  )

  return (
    <Block
      location="board"
      block={block}
      layout={layout}
      colWidth={colWidth}
      editMode={mode === 'edit'}
      active={active}
      {...props}
    />
  )
}

export default enhance(BlockContainer)
